import { Form } from '@unform/web';
import { addMinutes, isAfter, isBefore, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';
import SelectSimple from '../../../../../../components/Forms/SelectSimple';
import { useLoading } from '../../../../../../hooks/LoadingHook';
import { useModal } from '../../../../../../hooks/Modal';
import api from '../../../../../../services/api';
import { date, dateLanguageDate } from '../../../../../../utils/date';
import Input from '../../../../../DashboardPages/core/components/Forms/Input';
import FormComponent from '../../../../../DashboardPages/core/components/FormComponentUnique';
import { useToast } from '../../../../../../hooks/Toast';

interface IOptions {
    text?: string;
    label?: string;
    value: string;
}


interface IProps {
    
    setCallback: Function;
    hash?: string;

}

const UpdateStudentMulti: React.FC<IProps> = ({hash, setCallback }) => {
    const { addLoading, removeLoading } = useLoading();
    const { addModal, removeModal } = useModal();
    const {addToast} = useToast();
    


    const sendItems = async ( list) => {

    

 try {
            await api.put(`/update-visitation-student-list-admin/${hash}`, {data: list})

            removeModal('alunos-list');
            removeModal('atualizar-alunos-list');
            setCallback();
            removeLoading('loading');
        }
        catch (err) {
            addModal({ title: '', theme: 'whiteModalMini', content: <p style={{ color: '#333', fontSize: '12px' }}>{err?.response?.data?.message || err?.response?.data?.error || 'Erro ao atualizar aluno'}</p> })
            removeLoading('loading');
        }


    }
 

   const updateMulti = async (
    data: Record<string, any>,
  
  ): Promise<void> => {
    try {
      const formData = new FormData();
      formData.append('file', data.image)
      const response = await api.post(`/converter/xlsx-to-json`, formData);

      const dataItems : Record<string,any>[] = [];

      response?.data?.rows?.map( i => {

        if(i?.NOME){
            dataItems.push({
                name: i?.NOME,
                document_type: i?.['TIPO DE DOCUMENTO (CPF, RG, CN)'],
                rg: i?.['DOCUMENTO'],

            })


        }

      })


      addModal({title: '', content: <>
{dataItems?.length < 1 ?  <p style={{padding: '10px', width: '100%', textAlign:'center', color:'#333'}}>Nenhum nome identificado em sua lista </p> : <></>}
       
    {dataItems?.length > 0 ? <div className='column gap-sm full-width'>  <button onClick={() => { sendItems( dataItems)}} className='defaultButtonMini purpleContent'>Confirmar envio</button>
      
      <table className='tableRef'>
        <tbody>
                <tr>
                    <td>
NOME
                    </td>
                    <td>
DOCUMENTO
                    </td>
                    <td>
TIPO DE DOCUMENTO (CPF, RG, CN)
                    </td>

                </tr>
		{dataItems?.map( items => {

            return <tr>
                <td>{items?.name}</td>
                 <td>{items?.rg}</td>
                  <td>{items?.document_type}</td>
            </tr>

        })}



        </tbody>

      </table> </div> : <></>}
      
      </>, theme: 'whiteModalMedium', key:'alunos-list' })

     

    } catch (err) {
      console.log(err)

      return addToast({ type: 'error', title: err?.response?.data?.error || err?.response?.data?.message });
    }
  };

    return (
        <div className='column full-width gap'>
          <div className='row pad-sm full-width'>
        <a href='/arquivos/importacao.xlsx' download><button className='defaultButtonMini purple'>Download do modelo</button></a>
</div>

        <p style={{padding: '10px', width: '100%', textAlign:'center', color:'#333'}}>Faça o upload com os dados dos estudantes </p>
           <FormComponent schema={{
        image: {
          model: 'uploadImage',
          type: 'upload',
          name: 'image',
          label: 'Excel com dados de estudantes',
        }
      }} setCallback={updateMulti} />

        </div>
    );
};
export default UpdateStudentMulti;
